module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('download-Popup'), _vm._v(" "), (_vm.isOperamini) ? _c('p', {
    staticClass: "operamini-tips"
  }, [_vm._v("\n        Untuk memberi Anda pengalaman yang lebih baik, silakan unduh aplikasi profesional kami.\n    ")]) : _vm._e(), _vm._v(" "), _c('navVue', {
    attrs: {
      "subtitleData": _vm.getVideoSubTabList,
      "navSelected": _vm.currentNavTag,
      "pad": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contentWrap",
    attrs: {
      "id": "contentWrap"
    }
  }, [(_vm.noDataMode) ? _c('nodata', {
    attrs: {
      "whiteMode": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getToggleLoadingShow) ? _c('loading') : _vm._e(), _vm._v(" "), (!_vm.noDataMode && !_vm.getToggleLoadingShow) ? _c('div', {
    staticClass: "listwrap"
  }, [_vm._l((_vm.getCurrentVideoListData), function(data, index) {
    return _c('div', {
      key: index,
      staticClass: "list"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: ("/news/" + (_vm.getUrlTitle(_vm.subtitChoose)) + "/" + (_vm.getUrlTitle(data.title)) + "/" + (data.id) + "?type=video")
        }
      }
    }, [_c('list-item', {
      attrs: {
        "listData": data,
        "firstTit": _vm.firstTit,
        "subtit": _vm.subtitChoose
      }
    })], 1)], 1)
  }), _vm._v(" "), (_vm.getVideoLoadingShow) ? _c('loading') : _vm._e(), _vm._v(" "), (!_vm.getVideoLoadingShow && !_vm.getVideoLoadNext) ? _c('div', {
    staticClass: "noMoreDatas"
  }, [_vm._v("\n                Tidak Ada Data Lagi\n            ")]) : _vm._e()], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-671fec54","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppVideo.vue
// module id = 636
// module chunks = 6